import types from './types';

const {
  CLEAN_UP,
  CHECK_EMAIL, CHECK_EMAIL_SUCCESS, CHECK_EMAIL_FAIL,
} = types;

export function cleanup() {
  return { type: CLEAN_UP };
}

export function checkEmailExists(email) {
  return {
    types: [CHECK_EMAIL, CHECK_EMAIL_SUCCESS, CHECK_EMAIL_FAIL],
    promise: client => client.get(`GuestAccounts/checkGuestByEmail?email=${email}`),
  };
}
